import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/Button';
import { Tooltip } from '@/components/ui/Tooltip';

interface BarItemProps {
  onClick?: () => void;
  'data-testid'?: string;
}

interface BarProps {
  text?: string;
  count?: number;
  content?: React.ReactElement<BarItemProps>[];
  actions?: React.ReactNode;
  className?: string;
}

const Bar: React.FC<BarProps> = ({ text, count, content, actions }) => {
  return (
    <div className="h-12 border-b shrink-0 border-neutral-150 flex items-center justify-between px-4">
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-semibold text-neutral-900">{text}</h3>
        {count != null && (
          <Badge variant="outline" size="sm" className="font-mono">
            {count}
          </Badge>
        )}
      </div>
      <div className="flex items-center gap-0.5">
        {actions}
        {content?.map((item, i) => {
          const { onClick, 'data-testid': testId } = item.props;
          const icon = React.cloneElement(item, { onClick: undefined, 'data-testid': undefined });

          return (
            <Tooltip key={i} content="">
              <Button
                variant="ghost"
                size="icon-sm"
                type="button"
                onClick={onClick}
                data-testid={testId ?? `bar-action-${i}`}
              >
                {icon}
              </Button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default Bar;
